module.exports = __webpack_public_path__ + "static/city-5cf30e301d1290cee1386c1acb607680.jpg";